import request from '@/utils/request'

// 获取商品全部分类
export const getCategoryApi = () => {
  return request.get('/category/list')
}
